import Vue from 'vue'
import Vuex from 'vuex'
import general from './general'
import predial from './predial'
import inyco from './inyco'
import pse from './pse'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    general,
    predial,
    inyco,
    pse
  }
})
